module.exports = __webpack_public_path__ + "img/4-1.18d40c89.png";